import React from 'react';

const Sidebar = ({ user, onLogout, activeTab, setActiveTab }) => {
  const menu = [
    { id: 'overview', label: 'Tableau de bord', icon: 'bi-speedometer2' },
    { id: 'flash', label: 'Flash Info', icon: 'bi-megaphone' },
    { id: 'programme', label: 'Grille Programmes', icon: 'bi-calendar3' },
    { id: 'videos', label: 'Gestion Vidéos', icon: 'bi-play-circle' },
    { id: 'partners', label: 'Gestion Partenaires', icon: 'bi-hand-thumbs-up' },
  ];

  return (
    <>
      {/* MOBILE NAV (Top) */}
      <div className="d-md-none bg-dark border-bottom border-secondary sticky-top w-100" style={{ zIndex: 1100 }}>
        <div className="d-flex overflow-auto p-2 gap-2" style={{ whiteSpace: 'nowrap', scrollbarWidth: 'none' }}>
          {menu.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setActiveTab(item.id)}
              className={`btn btn-sm px-3 rounded-pill fw-bold ${
                activeTab === item.id ? 'btn-warning text-dark' : 'btn-outline-secondary text-white border-0'
              }`}
            >
              {item.label}
            </button>
          ))}
          <button type="button" onClick={onLogout} className="btn btn-sm btn-outline-danger border-0 ms-auto">
            <i className="bi bi-power"></i>
          </button>
        </div>
      </div>

      {/* DESKTOP SIDEBAR */}
      <aside className="d-none d-md-flex flex-column border-end border-secondary bg-dark shadow-lg" style={{ width: '280px', minHeight: '100vh', position: 'sticky', top: 0 }}>
        <div className="p-4 border-bottom border-secondary text-center bg-black bg-opacity-10">
          <h2 className="fw-black italic tracking-tighter text-uppercase mb-0 text-white">
            FRÉQUENCE<span className="text-danger">974</span>
          </h2>
          <small className="text-info text-uppercase fw-bold" style={{ fontSize: '9px', letterSpacing: '2px' }}>Studio Digital</small>
        </div>

        <nav className="flex-grow-1 p-3 mt-2 overflow-auto" style={{ paddingBottom: '30px' }}>
          {menu.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setActiveTab(item.id)}
              className={`btn w-100 text-start border-0 rounded-4 px-4 py-3 mb-2 d-flex align-items-center ${
                activeTab === item.id ? 'bg-warning text-dark fw-black shadow-sm' : 'text-secondary bg-transparent fw-bold opacity-75'
              }`}
            >
              <i className={`bi ${item.icon} me-3`}></i>
              <span className="text-uppercase small tracking-tighter">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="p-4 mb-3 border-top border-secondary bg-black bg-opacity-25">
          <button type="button" onClick={onLogout} className="btn btn-outline-danger w-100 rounded-pill btn-sm fw-black text-uppercase tracking-widest">
            DÉCONNEXION
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;